export default __webpack_public_path__ + "github-character.png";